import {
  Skeleton,
  DefaultPageSkeleton,
  BaseLayout,
  Header
} from '@efast_public/fjd-component-library';

export function LayoutSkeleton() {
  return (
    <BaseLayout
      footer={<Skeleton width={1000} height={40} />}
      header={
        <Header
          logo={<Skeleton width={200} height={40} />}
          navigation={<Skeleton width={200} height={40} />}
        />
      }
      mainContent={
        <div style={{ padding: '120px' }}>
          <DefaultPageSkeleton />
        </div>
      }
    />
  );
}
